/**
 * Helper functions to manage redirect URLs for authentication flow
 */

// Storage key for the redirect URL
const REDIRECT_URL_KEY = 'intended_redirect_url';
const ALLOWED_URLS = ['/settings/subscriptions'];

/**
 * Saves the URL that the user was trying to access before being redirected to login
 * @param {string} url - The URL to save
 */
export const saveIntendedUrl = (url) => {
  if (url && ALLOWED_URLS.includes(url)) {
    console.log('Saving intended URL:', url);
    localStorage.setItem(REDIRECT_URL_KEY, url);
  }
};

/**
 * Gets the saved URL that the user was trying to access
 * @returns {string|null} The saved URL or null if none exists
 */
export const getIntendedUrl = () => {
  const url = localStorage.getItem(REDIRECT_URL_KEY);
  console.log('Getting intended URL:', url);
  return url;
};

/**
 * Clears the saved redirect URL
 */
export const clearIntendedUrl = () => {
  console.log('Clearing intended URL');
  localStorage.removeItem(REDIRECT_URL_KEY);
};
